<template>
  <van-sticky>
    <van-nav-bar :border="false" :style="navBgStyle" safe-area-inset-top @click-left="hr.goBack()">
      <template v-if="!hideBack" #left>
        <van-icon name="arrow-left" size="21" :color="navTextColor"/>
      </template>
      <template #title>
        <div style="display:flex;gap:20px;">
          <div v-for="(tab, index) in tabs" :key="tab"
               @click="onTabClick(index)"
               :style="{
                 fontSize: activeTab === index ? '17px' : '14px',
                 color: activeTab === index ? navTextColor : navInactiveColor,
                 fontWeight: 'bold',
                 transition: 'font-size 0.3s',
                 cursor: 'pointer',
               }">
            {{ tab }}
          </div>
        </div>
      </template>
    </van-nav-bar>
  </van-sticky>
  <van-swipe ref="swipeRef" :loop="false" lazy-render :show-indicators="false" :initial-swipe="activeTab" @change="onSwipeChange">
    <van-swipe-item>
      <Pay :hideLeftBackBtn="true" :hideNav="true"/>
    </van-swipe-item>
    <van-swipe-item>
      <Withdraw :hideNav="true"/>
    </van-swipe-item>
  </van-swipe>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue';
import {useRoute} from 'vue-router';
import {hr} from "@/components/utils/HRouter.js";
import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
import Pay from "@/components/pages/Pay.vue";
import Withdraw from "@/components/pages/Withdraw.vue";

const props = defineProps({
  hideBack: {default: false},
});

const route = useRoute();
const activeTab = ref(route.path === '/withdraw' ? 1 : 0);
const tabs = ['充值', '提现'];
const swipeRef = ref();

const navBgStyle = computed(() => {
  const t = HNewGameUIConfig.newGameUIType;
  const bg = t === 1 ? '#FFE88A' : t === 2 ? '#FF7373' : t === 3 ? '#111111' : 'white';
  return {backgroundColor: bg};
});

const navTextColor = computed(() => {
  const t = HNewGameUIConfig.newGameUIType;
  return (t === 2 || t === 3) ? 'white' : 'black';
});

const navInactiveColor = computed(() => {
  const t = HNewGameUIConfig.newGameUIType;
  return (t === 2 || t === 3) ? '#aaa' : '#999';
});

function onTabClick(index) {
  activeTab.value = index;
  swipeRef.value?.swipeTo(index);
}

function onSwipeChange(index) {
  activeTab.value = index;
}
</script>

<style scoped>
</style>
